import React from "react";
import { Link } from "react-router-dom";

/**
 * Boton que dirige a la pagina de ayuda sin login
 * @returns {JSX.Element} HelpButton
 */
export const HelpButton = ({texts}) => {
    return (
        <Link  to="/ayuda-sin-login" className="link-ayuda">
            <p className="text-center">{texts?.title || '¿Tienes alguna duda?'}</p>
            <span>{texts?.boton || 'entra aquí'}</span>
        </Link>
    )
}